var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{class:_vm.labelClasses},[_vm._t("label")],2),_c('div',{class:_vm.valueClasses},[_vm._t("value")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }